module.exports = __webpack_public_path__ + "img/Tyagi.b927712b.jpeg";